module.exports = __webpack_public_path__ + "img/Graph_Orange_Icon.a52f0c0d.png";